import { forwardRef } from 'react';
import { heroValuePartner } from '../../../constants/partnerPageConst';
import { HeroComponent } from '../../Common/HeroComponent';
import { IPageSection, ProductId } from '../types';
import { AdvertisedFeatures, AdvertisedProducts } from './advert-card/constant';
import { collectionType } from '../../../types/partner-page-types';

export const HeroSection: React.FC<IPageSection> = forwardRef(
  ({ id, postData }, ref: React.ForwardedRef<HTMLDivElement>): JSX.Element => {
    const heading = postData?.heroTitle || heroValuePartner.heading;
    const isSelfFilingActive = postData?.self_itr?.active === true;
    const isEasItrActive = postData?.eas_itr?.active === true;
    const filteredAdvertisedProducts = AdvertisedProducts.filter((product) => {
      if (
        postData?.collection === collectionType.corporates &&
        product.id === ProductId.EasItr
      ) {
        return false;
      }
      if (product.id === ProductId.SelfFiling) {
        return isSelfFilingActive;
      }
      if (product.id === ProductId.EasItr) {
        return isEasItrActive;
      }
      return true;
    });

    const advertCardVisible = filteredAdvertisedProducts.length > 0;
    return (
      <div data-testid={id} id={id} ref={ref}>
        {postData ? (
          <>
            <HeroComponent
              AdvertisedProducts={filteredAdvertisedProducts}
              advertCardVisible={advertCardVisible}
              headingclass="text-s-36 sm:text-s-36 mb-6 sm:mb-4"
              videoAutoPlay={false}
              heading={heading}
              descriptionClasses="w-4/5 pt-1 pb-4 mb-0 sm:w-full sm:pb-0 sm:mb-0"
              subHeading={postData.headerTitle}
              pocEmail={postData.pocEmail}
              pocPhone={postData.pocPhone}
              pocName={postData.pocName}
              webinarUrl={postData.webinarUrl}
              pageType="partner"
              AdvertisedFeatures={AdvertisedFeatures}
              videoSource={heroValuePartner.videoSource}
              videoSourceWebm={heroValuePartner.videoSourceWebm}
              companyLogo={postData.logo}
              companyLink={postData.logoRedirection}
              videoPoster={heroValuePartner.videoPoster}
              containerClasses="pb-0 sm:pb-0"
              postData={postData}
            />
          </>
        ) : null}
      </div>
    );
  }
);

HeroSection.displayName = 'HeroSection';
